/**
 * @description 处理卡片点击逻辑的 Hook，支持在 NuxtLink/a 标签内进行文字选择而不触发跳转
 * @returns {Object} 包含 handleCardClick 方法
 */
export const useCardSelection = () => {
  /**
   * @description 处理点击事件，如果当前有选中的文字，则阻止默认行为和冒泡
   * @param {MouseEvent} e - 原生点击事件
   */
  const handleCardClick = (e) => {
    if (!import.meta.client) return

    // 如果有选中的文本，说明用户在进行复制操作
    if (window.getSelection()?.toString()) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  return {
    handleCardClick,
  }
}
